import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";

/** Capability check for person Groups. Denied users are redirected to person overview. */
export function usePersonGroupsAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonGroups = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonGroups
  });

  return {
    loaded,
    canViewPersonGroups
  };
}
